type Props = {
  color: string;
};

function ColorComponent({ color }: Props) {
  return (
    <div className="h-5 w-5 rounded-full" style={{ backgroundColor: color }} />
  );
}

export default ColorComponent;
